export const mmidInitParamsStorage: string = "mmidInitParams";

export const mmidPrefixSize: number = 10;

export const mmidPrefixStorage: string = "mmidPrefixStorage";